import { Slice } from "../store.decl";

import { GetCompanyQuery } from "@/graphql/generated/graphql";
import { Unpacked } from "@/helpers/types/types.helpers";

export type CompanyTag = Unpacked<GetCompanyQuery["getCompany"]["tags"]>;

export type CompanyTagsSliceState = {
  companyTags: CompanyTag[];
  setCompanyTags: (tags: CompanyTag[]) => void;
};

export const createCompanyTagsSlice: Slice<CompanyTagsSliceState> = (set) => ({
  companyTags: [],
  setCompanyTags: (companyTags) => {
    set(() => ({
      companyTags,
    }));
  },
});
